import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConstant } from '../common/constant/api-constant';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }

  public GetStatus() {
    return this.http.post(ApiConstant.DashboardApi.Status, {});
  }
  // public GetActiveATM() {
  //   return this.http.post(ApiConstant.DashboardApi.GetActiveATM, {});
  // }
  // public GetActiveCustomer() {
  //   return this.http.post(ApiConstant.DashboardApi.GetActiveCustomer, {});
  // }
  // public GetLatestWaterDispenses() {
  //   return this.http.post(ApiConstant.DashboardApi.GetLatestWaterDispenses, {});
  // }
  // public GetMonthlyWaterDispense() {
  //   return this.http.post(ApiConstant.DashboardApi.GetMonthlyWaterDispense, {});
  // }
  // public GetNewAccountCountByMonth() {
  //   return this.http.post(ApiConstant.DashboardApi.GetNewAccountCountByMonth, {});
  // }
  // public GetPumpList() {
  //   return this.http.post(ApiConstant.DashboardApi.GetPumpList, {});
  // }
  // public GetRechargeSumByMonth() {
  //   return this.http.post(ApiConstant.DashboardApi.GetRechargeSumByMonth, {});
  // }
  // public GetTodayWaterDispense() {
  //   return this.http.post(ApiConstant.DashboardApi.GetTodayWaterDispense, {});
  // }
  // public GetWaterDispenseSumByMonth() {
  //   return this.http.post(ApiConstant.DashboardApi.GetWaterDispenseSumByMonth, {});
  // }
 


 
}
